import React from 'react';
import List from '../../../containers/rest/List';
import RestFieldItem from '../../../components/RestField/RestFieldItem';
import ActionGroup from '../../../components/RestActions/ActionGroup';
import EditButton from '../../../components/RestActions/EditButton';
import DeleteButton from '../../../components/RestActions/DeleteButton';

const ServiceTypesList = props => (
  <List {...props} isScroll={false} resource="serviceTypes">
    <RestFieldItem source="name" header="serviceTypes.name" />
    <RestFieldItem source="description" header="serviceTypes.description" />
    <ActionGroup>
      <EditButton />
      <DeleteButton isSortDelete />
    </ActionGroup>
  </List>
);

ServiceTypesList.propTypes = {};

export default ServiceTypesList;
